<app-venue-template-table [datasource]="datasource" (templateDeleted)="deleteTemplate($event)" ></app-venue-template-table>
<mat-paginator [pageSizeOptions]="pageSizeOptions"></mat-paginator>
<mat-spinner *ngIf="datasource.loading$ | async"></mat-spinner>